<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="archive-page">
    <div class="page-header">
      <h1>بایگانی</h1>
      <p>مدیریت و نگهداری اسناد و مدارک</p>
    </div>
    
    <div class="content-grid">
      <div class="card">
        <div class="card-header">
          <h3>بایگانی اسناد</h3>
        </div>
        <div class="card-body">
          <p>ذخیره و طبقه‌بندی اسناد مهم</p>
          <BaseButton title="دسترسی به بایگانی" variant="primary" type="button" />
        </div>
      </div>
      
      <div class="card">
        <div class="card-header">
          <h3>جستجوی اسناد</h3>
        </div>
        <div class="card-body">
          <p>جستجو و بازیابی سریع اسناد</p>
          <BaseButton title="جستجو" variant="primary" type="button" />
        </div>
      </div>
      
      <div class="card">
        <div class="card-header">
          <h3>طبقه‌بندی</h3>
        </div>
        <div class="card-body">
          <p>مدیریت دسته‌بندی و کدگذاری اسناد</p>
          <BaseButton title="مدیریت طبقه‌بندی" variant="primary" type="button" />
        </div>
      </div>
      
      <div class="card">
        <div class="card-header">
          <h3>گزارش‌های بایگانی</h3>
        </div>
        <div class="card-body">
          <p>گزارش‌های آماری و تحلیلی</p>
          <BaseButton title="مشاهده گزارش‌ها" variant="primary" type="button" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
// منطق کامپوننت بایگانی
</script>

<style scoped>
.archive-page {
  padding: 2rem;
  direction: rtl;
}

.page-header {
  margin-bottom: 2rem;
  text-align: center;
}

.page-header h1 {
  color: var(--text-color-primary);
  margin-bottom: 0.5rem;
}

.page-header p {
  color: var(--text-color-secondary);
}

.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.card {
  background: var(--background-color);
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  padding: 1.5rem;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.card-header h3 {
  color: var(--text-color-primary);
  margin-bottom: 1rem;
}

.card-body p {
  color: var(--text-color-secondary);
  margin-bottom: 1rem;
}

</style>
